














import Vue from 'vue'
import { Component } from 'vue-property-decorator'
import ErrorInfoPage from '@/components/errors/page/ErrorInfoPage.vue'
import Login from '@/components/login/Login.vue'

@Component({
  components: { ErrorInfoPage, Login }
})
export default class App extends Vue {
  /**  */

  private beforeRouteLeave(to: any, from: any, next: any): void {
    alert('App')
    this.$tcw.$store.errors.clear()
    next()
  }
}
